"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLinkOpenButtonState = exports.useLinkOpenButton = exports.LinkOpenButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _plateCommon = require("@udecode/plate-common");
var _plateLink = require("@udecode/plate-link");
var useLinkOpenButtonState = function useLinkOpenButtonState() {
  var editor = (0, _plateCommon.useEditorRef)();
  var selection = (0, _plateCommon.useEditorSelection)();
  var entry = _react.default.useMemo(function () {
    return (0, _plateCommon.findNode)(editor, {
      match: {
        type: (0, _plateCommon.getPluginType)(editor, _plateLink.ELEMENT_LINK)
      }
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [editor, selection]);
  if (!entry) {
    return {};
  }
  var _entry = _slicedToArray(entry, 1),
    element = _entry[0];
  return {
    element: element
  };
};
exports.useLinkOpenButtonState = useLinkOpenButtonState;
var useLinkOpenButton = function useLinkOpenButton(_ref) {
  var element = _ref.element;
  var editor = (0, _plateCommon.useEditorRef)();
  if (!element) {
    return {
      props: {}
    };
  }
  var linkAttributes = (0, _plateLink.getLinkAttributes)(editor, element);
  return {
    props: _objectSpread({}, linkAttributes, {
      'aria-label': 'Open link in a new tab',
      onMouseOver: function onMouseOver(e) {
        e.stopPropagation();
      },
      target: '_blank'
    })
  };
};
exports.useLinkOpenButton = useLinkOpenButton;
var LinkOpenButton = exports.LinkOpenButton = (0, _plateCommon.createPrimitiveComponent)('a')({
  propsHook: useLinkOpenButton,
  stateHook: useLinkOpenButtonState
});